import { useQuery } from "react-query";
import { AxiosResponse } from "axios"

import { IUser } from "providers/AppProvider/AppProviderTypes";

import usersService from "api/usersService";

interface IUseGetUserArgs {
  enabled: boolean
  isAuthenticated: boolean
}

const useGetUser = ({ enabled, isAuthenticated }: IUseGetUserArgs) => (
  useQuery(["user", isAuthenticated], async () => {
    try {
      const res: AxiosResponse<IUser> = await usersService.getUser()

      return res.data
    } catch (err: any) {
      return err.response
    }
  }, 
  { enabled, refetchOnWindowFocus: false }
  )
)

export default useGetUser